import { ChangeEvent } from "react";

import { InputComponentProps } from "../input";

export enum LabelPositionEnum {
	left,
	right,
	hidden,
}

export interface BaseProps extends InputComponentProps<any, boolean> {
	activeColor?: string;
	inactiveColor?: string;
	sliderBorderColor?: string;
	rounded?: boolean;
	labelPosition?: LabelPositionEnum;
	small?: boolean;
	trueLabel?: string;
	falseLabel?: string;
}

export interface MarkupProps extends BaseProps {
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	focused: boolean;
	updateFocused: () => void;
}
